export default {
  nav: {
    home: "Главная",
    services: "Услуги",
    about: "О нас",
    contact: "Контакты",
    book: "Записаться",
  },
  hero: {
    badge: "Осн. 2012 — Более 3,800 клиентов",
    line1: "Чистое пространство,",
    line2: "Чистый разум.",
    sub: "Профессиональная уборка для домов и бизнеса — с точностью, заботой и вниманием к деталям.",
    btn1: "Заказать уборку",
    btn2: "Наши услуги",
    scroll: "Прокрутить",
  },
  partners: "Наши партнёры",
  stats: {
    exp: "Лет опыта",
    clients: "Обслуженных клиентов",
    satisfaction: "Уровень удовлетворённости",
    support: "Поддержка",
  },
  services: {
    pageTitle: "Наши услуги — Cleaning Holding",
    pageMeta: "Ознакомьтесь с полным спектром услуг Cleaning Holding.",
    pageSubtitle:
      "Каждая услуга выполняется с одинаковой приверженностью качеству — точно, тщательно и индивидуально.",
    label: "Что мы предлагаем",
    title: "Наши услуги",
    ctaTitle: "Готовы начать?",
    ctaSub: "Свяжитесь с нами для бесплатной консультации.",
    ctaBtn: "Запросить консультацию",
    learnMore: "Подробнее",
    viewAll: "Все услуги",
    residential: {
      title: "Уборка жилья",
      subtitle: "Ваш дом — безупречен",
      desc: "Премиум уборка дома по вашему расписанию.",
      fullDesc:
        "Мы относимся к каждому дому как к своему собственному. Наши специалисты используют экологически чистые продукты премиум класса.",
      f1: "Регулярная уборка",
      f2: "Уборка каждой комнаты",
      f3: "Санитария кухни и ванной",
      f4: "Полировка окон и поверхностей",
    },
    commercial: {
      title: "Коммерческая уборка",
      subtitle: "Пространства, которые вдохновляют",
      desc: "Уборка офисов и объектов высокого класса.",
      fullDesc:
        "Первое впечатление важно. Мы поддерживаем безупречную чистоту в офисах, торговых помещениях и объектах.",
      f1: "Уборка офиса",
      f2: "Уборка торговых помещений",
      f3: "Уборка после мероприятий",
      f4: "Регулярное обслуживание объектов",
    },
    deep: {
      title: "Генеральная уборка",
      subtitle: "От пола до потолка",
      desc: "Тщательная уборка от пола до потолка.",
      fullDesc:
        "Когда обычной уборки недостаточно. Наша генеральная уборка охватывает каждый угол, щель и поверхность.",
      f1: "Полная уборка объекта",
      f2: "Чистка бытовой техники",
      f3: "Восстановление затирки плитки",
      f4: "Чистка вентиляции",
    },
    move: {
      title: "Уборка при переезде",
      subtitle: "Чистый старт и финал",
      desc: "Чистый старт или чистый финал.",
      fullDesc:
        "Переезд сам по себе стрессовый. Доверьте уборку нам, чтобы сосредоточиться на главном.",
      f1: "Полная санитария",
      f2: "Чистка шкафов и ящиков",
      f3: "Удаление пятен со стен",
      f4: "Уборка для сдачи арендодателю",
    },
    construction: {
      title: "Постстроительная уборка",
      subtitle: "Откройте скрытую красоту",
      desc: "Специализированная постстроительная уборка.",
      fullDesc:
        "После строительства остаётся пыль, мусор и остатки материалов. Мы превращаем стройплощадку в готовое жильё.",
      f1: "Удаление пыли и мусора",
      f2: "Полировка поверхностей и полов",
      f3: "Мойка окон и стекла",
      f4: "Финальная проверка",
    },
    recurring: {
      title: "Регулярные пакеты",
      subtitle: "Стабильное совершенство",
      desc: "Еженедельные, двухнедельные и ежемесячные пакеты.",
      fullDesc:
        "Поддерживайте стандарт. Наши пакеты гарантируют, что ваше пространство всегда готово к приёму гостей.",
      f1: "Еженедельно / раз в 2 нед. / ежемесячно",
      f2: "Выделенная команда",
      f3: "Индивидуальный чек-лист",
      f4: "Приоритетное расписание",
    },
  },
  process: {
    label: "Как это работает",
    title: "Наш процесс",
    step1: {
      title: "Онлайн-бронирование",
      desc: "Выберите услугу и удобную дату за несколько минут.",
    },
    step2: {
      title: "Мы подтверждаем",
      desc: "Наша команда рассмотрит и подтвердит бронирование в течение 2 часов.",
    },
    step3: {
      title: "Мы убираем",
      desc: "Обученные специалисты приедут вовремя со всем оборудованием.",
    },
    step4: {
      title: "Наслаждайтесь",
      desc: "Осмотрите результат и наслаждайтесь чистотой.",
    },
  },
  cta: {
    title: "Готовы к чистоте?",
    sub: "Получите бесплатную консультацию сегодня.",
    btn: "Бесплатная консультация",
  },
  about: {
    pageTitle: "О нас — Cleaning Holding",
    pageMeta: "Узнайте о Cleaning Holding — 12 лет премиум уборки.",
    label: "Наша история",
    title: "О нас",
    subtitle:
      "Десятилетие преданности, тысячи довольных клиентов и один неизменный стандарт — совершенство.",
    since: "С 2012 года",
    storyTitle: "Построено на доверии",
    story1:
      "Cleaning Holding была основана в 2012 году с простой, но мощной идеей: каждое пространство заслуживает заботы и точности. Начав как небольшая компания по уборке жилья, мы выросли в полноценную сервисную компанию, которой доверяют тысячи домов и предприятий.",
    story2:
      "За последние 12 лет мы создали репутацию надёжности, дискретности и неизменной приверженности качеству. Наши клиенты не просто нанимают нас — они нам доверяют.",
    quote:
      "Мы не просто убираем пространство — мы возвращаем ощущение спокойствия, порядка и гордости в каждую среду.",
    valuesLabel: "Что нас движет",
    valuesTitle: "Наши ценности",
    teamLabel: "Люди за совершенством",
    teamTitle: "Познакомьтесь с командой",
    ctaTitle: "Давайте работать вместе",
    ctaSub: "Почувствуйте разницу Cleaning Holding на первом же сервисе.",
    ctaBtn: "Связаться с нами",
    values: {
      v1: {
        title: "Премиум качество",
        desc: "Используем только лучшие эко-сертифицированные продукты и строгий контроль качества.",
      },
      v2: {
        title: "Доверие и честность",
        desc: "Полностью проверенные, застрахованные профессионалы, которым можно доверять.",
      },
      v3: {
        title: "Надёжность",
        desc: "Вовремя, каждый раз. Мы уважаем ваше расписание и обеспечиваем стабильные результаты.",
      },
      v4: {
        title: "Экологичность",
        desc: "Устойчивые решения для уборки, защищающие вашу семью, питомцев и окружающую среду.",
      },
    },
    team: { exp: "опыта" },
  },
  contact: {
    pageTitle: "Контакты — Cleaning Holding",
    pageMeta: "Свяжитесь с Cleaning Holding для бесплатной консультации.",
    label: "Свяжитесь с нами",
    title: "Контакты",
    subtitle:
      "Готовы к чистоте? Напишите нам и мы ответим в течение 2 часов с бесплатной оценкой.",
    formTitle: "Отправить сообщение",
    formSub: "Ответим в течение 2 рабочих часов.",
    name: "Полное имя",
    email: "Эл. почта",
    phone: "Номер телефона",
    service: "Нужная услуга",
    message: "Сообщение",
    selectService: "Выберите услугу...",
    send: "Отправить",
    successTitle: "Спасибо!",
    successMsg:
      "Ваше сообщение получено. Наш специалист свяжется с вами в ближайшее время.",
    infoTitle: "Контактная информация",
    infoSub: "Всегда рады вас слышать.",
    whyTitle: "Почему мы",
    why1: "Бесплатная консультация и оценка",
    why2: "Ответ в течение 2 часов",
    why3: "Полностью застрахованная команда",
    why4: "Гибкое расписание",
    address: "Адрес",
    phoneLabel: "Телефон",
    emailLabel: "Эл. почта",
    hoursLabel: "Рабочие часы",
    services: {
      residential: "dalageba, Уборка жилья",
      commercial: "dasuptaveba, Коммерческая уборка",
      deep: "Генеральная уборка",
      moveinout: "Уборка при переезде",
      postconstruction: "Постстроительная уборка",
      recurring: "Регулярный пакет",
    },
  },
};
